{
  "common.close": "बंद करा",
  "common.athleteFallback": "खेळाडू {id}",
  "splash.title": "{app} — उपक्रमांचे ॲनिमेटेड चित्रण",
  "splash.tagline": "तुमच्या&nbsp;Strava डेटासाठी हलता नकाशा",
  "splash.demo": "डेमो",
  "tab.query.title": "{name} यांचा नकाशा",
  "tab.query.heading": "उपक्रम शोधा:",
  "tab.query.optDays": "अलीकडचे दिवस",
  "tab.query.optActivities": "अलीकडचे उपक्रम",
  "tab.query.optIds": "उपक्रम ID",
  "tab.query.optDates": "तारखांची मर्यादा",
  "tab.query.idsPlaceholder": "उपक्रम ID येथे टाका",
  "tab.query.after": "नंतर:",
  "tab.query.before": "आधी:",
  "tab.query.autozoom": "इम्पोर्टनंतर निकालावर आपोआप झूम <i class=\"hf hf-bullseye\"></i> करा",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> शोधा",
  "tab.query.createAccount": "खाते तयार करा आणि/किंवा लॉग इन करा.",
  "tab.query.sports": "खेळ:",
  "tab.query.allSports": "सर्व खेळ",
  "tab.query.sportsExcept": "सर्व, यांखेरीज",
  "tab.query.sportsNone": "एकही नाही",
  "tab.query.loadingSports": "खेळ लोड होत आहेत…",
  "tab.query.sportsFailed": "या नकाशाचे खेळ लोड करता आले नाहीत",
  "tab.query.noSports": "अद्याप कोणतीही क्रिया नाही",
  "tab.activities.title": "दाखवलेले उपक्रम",
  "tab.activities.clearSelection": "निवड काढा",
  "tab.activities.renderSelected": "निवडलेले दाखवा",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> निवडीवर झूम करा",
  "tab.controls.title": "लेयर सेटिंग्ज",
  "tab.controls.timescale": "कालमान <i>&tau;</i>",
  "tab.controls.timescaleHint": "चालवण्याचा वेग",
  "tab.controls.period": "आवर्तन <i>T</i>",
  "tab.controls.periodHint": "उपक्रम ~ मॉडेल",
  "tab.controls.dotSize": "बिंदूचा आकार",
  "tab.controls.pathWidth": "मार्गाची रुंदी",
  "tab.controls.pathWidthHint": "शून्य केल्यास मार्ग लपतात",
  "tab.controls.colors": "रंग",
  "tab.controls.colorsHint": "रंगसंच फिरवा",
  "tab.controls.shadows": "सावल्या",
  "tab.profile.loginTitle": "लॉग इन",
  "tab.profile.anonNote": "तुमचे स्वतःचे उपक्रम पाहण्यासाठी आणि तुमचे Heatflask खाते सांभाळण्यासाठी Strava ने लॉग इन करा.",
  "tab.profile.loginLink": "Strava ने लॉग इन करा",
  "tab.profile.editOnStrava": "Strava वर तुमचे प्रोफाइल संपादित करा",
  "tab.profile.indexNote": "जलद पाहण्यासाठी आम्ही तुमच्या उपक्रमांच्या सारांशांची अनुक्रमणिका ठेवतो.",
  "tab.profile.viewIndex": "अनुक्रमणिका पाहा",
  "tab.profile.sharedMaps": "सामायिक नकाशे",
  "tab.profile.sharedMapsNote": "बंद: Heatflask वर तुमचे उपक्रम फक्त तुम्हीच पाहू शकता. चालू: तुमच्या नकाशाची लिंक ज्याच्याकडे आहे, तो तुम्ही Strava वर सार्वजनिक केलेले उपक्रम पाहू शकतो. तुमचे खासगी उपक्रम दोन्ही बाबतीत तुमचेच राहतात. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">गोपनीयता कशी काम करते</a>",
  "tab.profile.logout": "लॉग आउट",
  "tab.profile.deleteAccount": "खाते हटवा",
  "tab.profile.deleteConfirm": "तुमचे Heatflask खाते हटवायचे?\n\nयामुळे तुमचे अनुक्रमित उपक्रम काढले जातील आणि तुमच्या Strava डेटावरील Heatflask चा प्रवेश रद्द होईल. हे परत करता येणार नाही.",
  "tab.profile.languageHeading": "भाषा",
  "tab.profile.languageAuto": "आपोआप",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">भाषांतरे दुरुस्त करण्यास किंवा नवीन जोडण्यास आम्हाला मदत करा!</a>",
  "tab.profile.unitsHeading": "एकके",
  "tab.profile.unitsAuto": "आपोआप",
  "tab.profile.unitsMetric": "मेट्रिक (किमी, मी)",
  "tab.profile.unitsImperial": "इम्पीरियल (मैल, फूट)",
  "tab.profile.textSizeHeading": "अक्षरांचा आकार",
  "tab.profile.textSmaller": "लहान",
  "tab.profile.textReset": "सामान्य",
  "tab.profile.textLarger": "मोठा",
  "tab.profile.mapDefaultsHeading": "नकाशाची डीफॉल्ट सेटिंग",
  "tab.profile.mapDefaultsNote": "ज्या नकाशाची लिंक स्वतःची सेटिंग ठरवत नाही असा नकाशा उघडताना प्रत्येक वेळी याच बेसमॅप, भूप्रदेश आणि लेयर सेटिंग्जने सुरुवात करा. तुम्ही सामायिक केलेल्या लिंक तरीही तुम्हाला दिसते तेच नेमके दाखवतात.",
  "tab.profile.mapDefaultsSave": "माझी डीफॉल्ट म्हणून जतन करा",
  "tab.profile.mapDefaultsForget": "विसरा",
  "tab.info.title": "माहिती",
  "tab.info.controlsHeading": "नियंत्रणे",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ओढा",
  "tab.info.shiftDragDesc": "एका चौकटीत उपक्रम निवडा. टचस्क्रीनवर आधी <i class=\"hf-object-group\"></i> दाबा, मग एका बोटाने ओढा. शेवटी निवडलेल्या उपक्रमाचा तपशील दिसतो, आणि उपक्रमांची यादी त्यापर्यंत स्क्रोल होते.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ओढा",
  "tab.info.ctrlDragDesc": "नकाशा 3D मध्ये फिरवा आणि तिरका करा, किंवा दोन बोटे वापरा",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "साइडबार उघडा किंवा बंद करा",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "मागील किंवा पुढील साइडबार टॅब",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "साइडबार बंद करा",
  "tab.info.liveUrlHeading": "लाइव्ह URL",
  "tab.info.liveUrlDesc": "नकाशाचे दृश्य आणि ॲनिमेशनची सेटिंग पानाच्या URL मध्ये राहतात, त्यामुळे तुम्ही ज्याला ती पाठवाल त्याला तेच दृश्य दिसते.",
  "tab.info.videoHeading": "व्हिडिओ एक्सपोर्ट",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> बटण ॲनिमेशन MP4 म्हणून रेकॉर्ड करते: ते दाबा, नकाशाच्या हव्या त्या भागावर चौकट बसवा, आणि रेकॉर्ड करण्यासाठी पुन्हा दाबा. ॲनिमेशनचे एक पूर्ण आवर्तन रेकॉर्ड होते, त्यामुळे व्हिडिओ अखंड पुन्हा चालतो; {max} सेकंदांपेक्षा (Strava स्वीकारते तो सर्वात मोठा व्हिडिओ) लांब आवर्तन {max} वर कापले जाते.",
  "tab.info.contributeHeading": "योगदान द्या",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub वर पाठिंबा द्या",
  "tab.info.contactsHeading": "संपर्क",
  "map.basemapAndTerrain": "बेसमॅप आणि भूप्रदेश",
  "map.pauseAnimation": "ॲनिमेशन थांबवा",
  "map.resumeAnimation": "ॲनिमेशन पुन्हा सुरू करा",
  "capture.record": "व्हिडिओ रेकॉर्ड करा ({period} से. आवर्तन)",
  "capture.recordTruncated": "व्हिडिओ रेकॉर्ड करा (एक आवर्तन {period} से. आहे; फक्त पहिले {max} से. रेकॉर्ड होतील)",
  "capture.recordArea": "चौकटीतील भाग रेकॉर्ड करा",
  "capture.stop": "रेकॉर्डिंग थांबवा",
  "capture.selectionTooSmall": "निवड खूप लहान आहे",
  "capture.saved": "{name} जतन केले ({size})",
  "capture.cancelled": "रेकॉर्डिंग रद्द झाले",
  "capture.failed": "रेकॉर्डिंग अयशस्वी: {error}",
  "capture.loadingEncoder": "एन्कोडर लोड होत आहे…",
  "capture.waitingForMap": "नकाशा लोड होण्याची वाट…",
  "capture.encoding": "एन्कोड होत आहे… {percent}%",
  "capture.finalizing": "पूर्ण करत आहे…",
  "share.title": "या नकाशाची लिंक शेअर करा",
  "share.copied": "लिंक कॉपी झाली",
  "share.copiedUnshared": "लिंक कॉपी झाली — पण तुमचा नकाशा सामायिक नाही, त्यामुळे इतर कोणी तो उघडू शकत नाही. हे बदलण्यासाठी “सामायिक नकाशे” चालू करा.",
  "share.unshared": "तुमचा नकाशा सामायिक नाही, त्यामुळे इतर कोणी ही लिंक उघडू शकत नाही. हे बदलण्यासाठी “सामायिक नकाशे” चालू करा.",
  "share.copyThis": "ही लिंक कॉपी करा:",
  "update.available": "Heatflask ची नवीन आवृत्ती उपलब्ध आहे.",
  "update.reload": "पुन्हा लोड करा",
  "import.title": "इम्पोर्ट होत आहे",
  "import.stop": "थांबवा",
  "import.stopping": "थांबत आहे…",
  "import.contacting": "Strava शी संपर्क होत आहे…",
  "import.countOf": "उपक्रम: {total} पैकी {received}",
  "import.count": "उपक्रम: {received}",
  "import.waitStrava": "Strava च्या डाउनलोड मर्यादेमुळे {time} पर्यंत थांबले आहे. हे पान उघडे ठेवा; पुन्हा लोड केल्याने वेग वाढणार नाही.",
  "import.waitRationed": "आजचे जलद डाउनलोड संपले. उरलेले {time} ला हळू सुरू राहील. हे पान उघडे ठेवा.",
  "import.dailyLimit": "Strava ची दैनिक डाउनलोड मर्यादा संपली. {time} नंतर पुन्हा प्रयत्न करा.",
  "import.dailyRationed": "आजचा तुमचा Strava डाउनलोडचा वाटा संपला. {time} नंतर पुन्हा प्रयत्न करा.",
  "import.noActivitiesYet": "तुमच्या Strava खात्यात अजून कोणतीही ॲक्टिव्हिटी नाही. Strava वर एक रेकॉर्ड किंवा अपलोड करा, ती इथे दिसेल.",
  "table.noActivities": "एकही उपक्रम नाही",
  "table.untitled": "(शीर्षक नाही)",
  "activities.pageTitle": "{app} — उपक्रम अनुक्रमणिका",
  "activities.heading": "उपक्रम अनुक्रमणिका",
  "activities.fetching": "उपक्रम आणत आहे...",
  "activities.rateLimit": "Strava ची विनंती-मर्यादा पूर्ण झाली; {time} ला पुन्हा सुरू होईल",
  "activities.noData": "क्षमस्व, डेटा नाही &#128577;",
  "activities.colServerCache": "ट्रॅक सर्व्हरवर जतन (Mongo)",
  "activities.colBrowserCache": "ट्रॅक या ब्राउझरमध्ये जतन",
  "activities.cachedServer": "{id} चा ट्रॅक सर्व्हरवर जतन आहे",
  "activities.notCachedServer": "{id} चा ट्रॅक सर्व्हरवर जतन नाही",
  "activities.cachedBrowser": "{id} चा ट्रॅक या ब्राउझरमध्ये जतन आहे",
  "activities.notCachedBrowser": "{id} चा ट्रॅक या ब्राउझरमध्ये जतन नाही",
  "sport.AlpineSki": "अल्पाइन स्कीइंग",
  "sport.BackcountrySki": "बॅककंट्री स्कीइंग",
  "sport.Badminton": "बॅडमिंटन",
  "sport.Basketball": "बास्केटबॉल",
  "sport.Canoeing": "कॅनोइंग",
  "sport.Cricket": "क्रिकेट",
  "sport.Crossfit": "क्रॉसफिट",
  "sport.Dance": "नृत्य",
  "sport.EBikeRide": "ई-बाइक राइड",
  "sport.Elliptical": "इलिप्टिकल",
  "sport.EMountainBikeRide": "ई-माउंटन बाइक राइड",
  "sport.Golf": "गोल्फ",
  "sport.GravelRide": "ग्रेव्हल राइड",
  "sport.Handcycle": "हँडसायकल",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "भटकंती",
  "sport.IceSkate": "आइस स्केटिंग",
  "sport.InlineSkate": "इनलाइन स्केटिंग",
  "sport.Kayaking": "कयाकिंग",
  "sport.Kitesurf": "काइटसर्फिंग",
  "sport.MountainBikeRide": "माउंटन बाइक राइड",
  "sport.NordicSki": "नॉर्डिक स्कीइंग",
  "sport.Padel": "पॅडल",
  "sport.PhysicalTherapy": "फिजिओथेरपी",
  "sport.Pickleball": "पिकलबॉल",
  "sport.Pilates": "पिलाटेस",
  "sport.Racquetball": "रॅकेटबॉल",
  "sport.Ride": "सायकल राइड",
  "sport.RockClimbing": "प्रस्तरारोहण",
  "sport.RollerSki": "रोलर स्की",
  "sport.Rowing": "नौकानयन",
  "sport.Run": "धावणे",
  "sport.Sail": "शिडाची नौका",
  "sport.Skateboard": "स्केटबोर्ड",
  "sport.Snowboard": "स्नोबोर्ड",
  "sport.Snowshoe": "स्नोशू",
  "sport.Soccer": "फुटबॉल",
  "sport.Squash": "स्क्वॅश",
  "sport.StairStepper": "स्टेअर स्टेपर",
  "sport.StandUpPaddling": "स्टँड अप पॅडलिंग",
  "sport.Surfing": "सर्फिंग",
  "sport.Swim": "पोहणे",
  "sport.TableTennis": "टेबल टेनिस",
  "sport.Tennis": "टेनिस",
  "sport.TrailRun": "ट्रेल रन",
  "sport.Velomobile": "व्हेलोमोबाइल",
  "sport.VirtualRide": "आभासी राइड",
  "sport.VirtualRow": "आभासी नौकानयन",
  "sport.VirtualRun": "आभासी धावणे",
  "sport.Volleyball": "व्हॉलीबॉल",
  "sport.Walk": "चालणे",
  "sport.WeightTraining": "वजन प्रशिक्षण",
  "sport.Wheelchair": "व्हीलचेअर",
  "sport.Windsurf": "विंडसर्फिंग",
  "sport.Workout": "व्यायाम",
  "sport.Yoga": "योग"
}
